
export default {
    SET_SAMPLE(state, payload) {
      state.sampleState = payload
    }, 
    
    SET_MAININFO(state, payload) {
      state.mainInfo = payload
    }, 
    
    SET_MAINDATASTRUCTURE(state, payload) {
      state.mainDataStructure = payload
    }, 
    
    SET_ENDPOINT(state, payload) {
      state.endPoint = payload
    }, 
    
    SET_CALLBACK(state, payload) {
      state.whenSuccessCallback = payload
    }, 
    SET_PROFILEID(state, payload) {
      state.profileId = payload
    }, 

    SET_CURRENTMAININFO(state, payload) {
      state.currentMainInfo = payload
    }, 
    
    SET_CURRENTMAINDATASTRUCTURE(state, payload) {
      state.currentDataStructure = payload
    }, 
  

  }
  